import { useEffect, useState } from "react";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import { useAuth } from "@vionixasia/shared-components";

/**
 * True when the signed-in user has role "admin" in /users. Public pages use it
 * to show operator-only controls (finish receipts, the finish desk link)
 * without gating the page itself.
 */
export const useIsAdmin = () => {
  const { user } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let alive = true;
    if (!user) {
      setIsAdmin(false);
      return undefined;
    }
    (async () => {
      try {
        const snap = await getDoc(doc(getFirestore(), "users", user.uid));
        if (alive) setIsAdmin(snap.exists() && snap.data()?.role === "admin");
      } catch {
        if (alive) setIsAdmin(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [user]);

  return isAdmin;
};
